import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import Layout            from './components/layout/Layout';
import LoginPage         from './pages/LoginPage';
import DashboardPage     from './pages/DashboardPage';
import FacilitiesPage    from './pages/FacilitiesPage';
import FacilityDetailPage from './pages/FacilityDetailPage';
import ScoresPage        from './pages/ScoresPage';
import ComparePage       from './pages/ComparePage';
import CompliancePage    from './pages/CompliancePage';
import CertificationsPage from './pages/CertificationsPage';
import BMWPage           from './pages/BMWPage';
import VaccinationPage   from './pages/VaccinationPage';
import AlertsPage        from './pages/AlertsPage';
import ReportsPage       from './pages/ReportsPage';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'100vh' }}>
      <div style={{ fontSize:18, color:'#616161' }}>Loading…</div>
    </div>
  );
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/*" element={
        <ProtectedRoute>
          <Layout>
            <Routes>
              <Route path="/"                    element={<DashboardPage />} />
              <Route path="/facilities"          element={<FacilitiesPage />} />
              <Route path="/facilities/:id"      element={<FacilityDetailPage />} />
              <Route path="/scores"              element={<ScoresPage />} />
              <Route path="/compare"             element={<ComparePage />} />
              <Route path="/compliance"          element={<CompliancePage />} />
              <Route path="/certifications"      element={<CertificationsPage />} />
              <Route path="/bmw"                 element={<BMWPage />} />
              <Route path="/vaccination"         element={<VaccinationPage />} />
              <Route path="/alerts"              element={<AlertsPage />} />
              <Route path="/reports"             element={<ReportsPage />} />
              <Route path="*"                    element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
